import * as Sentry from '@sentry/react';
import env from '@beam-australia/react-env';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

if (env('SENTRY_ENABLED') === 'true') {
  Sentry.init({
    dsn: process.env.VITE_SENTRY_DSN,
    // Only error monitoring enabled
    integrations: [],
    environment: env('SENTRY_ENVIRONMENT'),
    release: process.env.SENTRY_RELEASE,
  });
}

const useAddUserToSentry = () => {
  const user = useSelector((state) => state.auth.currentUser);

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.id,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
};

export default useAddUserToSentry;
